import { ShieldAlert } from "lucide-react";
import { usePreparationExceptionWorkspace } from "./usePreparationExceptionWorkspace";
export function ExceptionOverrideView({ workspace }: { workspace: ReturnType<typeof usePreparationExceptionWorkspace> }) {
  const { open, setOpen, reason, setReason, saving, submit } = workspace;
  if (!open)
    return (
      <button
        type="button"
        className="material-preparation-override"
        onClick={() => setOpen(true)}
      >
        <ShieldAlert size={14} />
        Gerekçeli istisna
      </button>
    );
  return (
    <div className="material-preparation-override-form">
      <input
        value={reason}
        maxLength={1000}
        onChange={(event) => setReason(event.target.value)}
        placeholder="İstisna gerekçesi (zorunlu)"
        aria-label="Malzeme hazırlık istisna gerekçesi"
      />
      <button type="button" disabled={saving} onClick={() => void submit()}>
        {saving ? "Kaydediliyor…" : "İstisna ile kapat"}
      </button>
      <button type="button" disabled={saving} onClick={() => setOpen(false)}>
        Vazgeç
      </button>
    </div>
  );
}

export function ExceptionOverride(props: Parameters<typeof usePreparationExceptionWorkspace>[0]) {
  const workspace = usePreparationExceptionWorkspace(props);
  return <ExceptionOverrideView workspace={workspace} />;
}
